export const isMobile = () => window.matchMedia('only screen and (max-width: 1169px)').matches;

export const notEmpty = (val) => val && val.length > 0;

export const emptyFunction = () => {};

export const stopPropagation = (e) => { e.stopPropagation(); };

export const generateClassName = (addedClass) => {
  let className = ['input-field'];

  if (Array.isArray(addedClass)) {
    className = className.concat(addedClass);
  } else {
    className.push(addedClass);
  }
  return className.join(' ');
};

export const generateErrors = (errors) => {
  const errorMessage = errors.join(', ');
  const errorBool = (errors.length > 0).toString();

  return { errorMessage, errorBool };
};

export const debounce = (callback, wait = 300) => {
  let timeoutId = null;

  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(...args);
    }, wait);
  };
}

export const appointmentRequestedTooltip = (appointmentRequestedWindow) => (
  `You requested an appointment for ${appointmentRequestedWindow}. The agent will follow up to confirm.`
);

export const lastYear = () => {
  new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getFullYear();
}

export const inView = (el) => {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (
      window.innerHeight ||
      document.documentElement.clientHeight) &&
    rect.right <= (
      window.innerWidth ||
      document.documentElement.clientWidth)
  );
}

export const offScreen = (el) => {
  const rect = el.getBoundingClientRect();

  return rect.top < 0
    || rect.left < 0
    || rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
    || rect.right > (window.innerWidth || document.documentElement.clientWidth)
}

export const stopBodyScrolling = () => {
  document.body.style = 'overflow: hidden';
};

export const startBodyScrolling = () => {
  document.body.style = null;
};

export const formatPhoneNumber = (phone) => {
  if (phone) {
    let number = phone.replace(/\D/g, '').replace(/\s/g, '');
    let formattedNumber = '';

    if (number.substring(0, 1) === '1') {
      number = number.substring(1);
    }
    if (number.length > 0) {
      formattedNumber += `(${number.substring(0, 3)}`;
    }
    if (number.length > 3) {
      formattedNumber += `) ${number.substring(3, 6)}`;
    }
    if (number.length > 6) {
      formattedNumber += `-${number.substring(6, 10)}`;
    }
    if (number.length > 10) {
      formattedNumber = number;
    }

    return formattedNumber;
  }
  return '';
};

export const getAgentFromUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('open_agent');
};

export const setAgentInUrl = (agentUuid) => {
  const url = new URL(window.location);
  url.searchParams.set('open_agent', agentUuid);
  window.history.pushState({ open_agent: agentUuid }, '', url.toString());
};

export const removeAgentFromUrl = () => {
  const url = new URL(window.location);
  url.searchParams.delete('open_agent');
  window.history.pushState({ open_agent: null }, '', url.toString());
};
